export const EMAIL_REGEX =
  /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/

export const PHONE_REGEX = /^((\(\d{3}\) ?)|(\d{3}-))?\d{3}-\d{4}$/

export const CAP_REGEX = /^\$?[0-9]+?[0-9]*$/
